module.exports = __webpack_public_path__ + "static/img/cp_bg02.ebcd86b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/cp_bg02.png
// module id = kGOI
// module chunks = 1